<template>
  <div class="setting-info-body">
    <div>
      <div class="bind-title">
        <p>
          <a-icon type="info-circle" theme="filled" />
          为了您的权益与安全，请不要将登录密码透漏给他人，并且牢记您的新密码
        </p>
      </div>
      <div class="setting-info-content">
        <div class="bind-from">
          <a-form @submit="handleSubmit" :form="form">
            <a-form-item>
              <div class="pwd-form-item">
                <span class="setting-info-name">当前密码：</span>
                <a-input
                  v-decorator="['originPassword']"
                  :type="currentPasswordIcon ? 'text' : 'password'"
                  placeholder="请输入当前密码"
                  style="width: 400px"
                >
                  <a-icon
                    slot="suffix"
                    :type="currentPasswordIcon ? 'eye' : 'eye-invisible'"
                    @click="currentPasswordIcon = !currentPasswordIcon"
                    style="cursor: pointer"
                  />
                </a-input>
              </div>
            </a-form-item>
            <a-form-item>
              <div class="pwd-form-item">
                <span class="setting-info-name">新密码：</span>
                <a-input
                  v-decorator="['newPassword']"
                  :type="newPasswordIcon ? 'text' : 'password'"
                  placeholder="长度6-20位，字母/数字/标点符号至少包含两种"
                  style="width: 400px"
                >
                  <a-icon
                    slot="suffix"
                    :type="newPasswordIcon ? 'eye' : 'eye-invisible'"
                    @click="newPasswordIcon = !newPasswordIcon"
                    style="cursor: pointer"
                  />
                </a-input>
              </div>
            </a-form-item>
            <a-form-item>
              <div class="pwd-form-item">
                <span class="setting-info-name">确认新密码：</span>
                <a-input
                  v-decorator="['repeatNewPassword']"
                  :type="confirmNewPasswordIcon ? 'text' : 'password'"
                  placeholder="请再次输入您的新密码"
                  style="width: 400px"
                >
                  <a-icon
                    slot="suffix"
                    :type="confirmNewPasswordIcon ? 'eye' : 'eye-invisible'"
                    @click="confirmNewPasswordIcon = !confirmNewPasswordIcon"
                    style="cursor: pointer"
                  />
                </a-input>
              </div>
            </a-form-item>
            <a-form-item>
              <a-button
                htmlType="submit"
                class="btn-green"
                style="margin-left: 80px"
                >确认修改</a-button
              >
            </a-form-item>
            <!--          <div>-->
            <!--            <span class="setting-info-name">当前密码：</span>-->
            <!--            <a-input-->
            <!--              v-decorator="['originPassword']"-->
            <!--              :type="currentPasswordIcon?'text':'password'"-->
            <!--              placeholder="请输入当前密码"-->
            <!--              style="width: 400px"-->
            <!--            >-->
            <!--              <a-icon slot="suffix" :type="currentPasswordIcon?'eye':'eye-invisible'"-->
            <!--                      @click="currentPasswordIcon = !currentPasswordIcon" style="cursor: pointer;" />-->
            <!--            </a-input>-->
            <!--          </div>-->
            <!--          <div>-->
            <!--            <span class="setting-info-name">新密码：</span>-->
            <!--            <a-input-->
            <!--              v-decorator="['newPassword']"-->
            <!--              :type="newPasswordIcon?'text':'password'"-->
            <!--              placeholder="长度6-20位，字母/数字/标点符号至少包含两种"-->
            <!--              style="width: 400px"-->
            <!--            >-->
            <!--              <a-icon slot="suffix" :type="newPasswordIcon?'eye':'eye-invisible'"-->
            <!--                      @click="newPasswordIcon = !newPasswordIcon" style="cursor: pointer;" />-->
            <!--            </a-input>-->
            <!--          </div>-->
            <!--          <div>-->
            <!--            <span class="setting-info-name">确认新密码：</span>-->
            <!--            <a-input-->
            <!--              v-decorator="['repeatNewPassword']"-->
            <!--              :type="confirmNewPasswordIcon?'text':'password'"-->
            <!--              placeholder="请再次输入您的新密码"-->
            <!--              style="width: 400px"-->
            <!--            >-->
            <!--              <a-icon slot="suffix" :type="confirmNewPasswordIcon?'eye':'eye-invisible'"-->
            <!--                      @click="confirmNewPasswordIcon = !confirmNewPasswordIcon" style="cursor: pointer;" />-->
            <!--            </a-input>-->
            <!--          </div>-->
            <!--          <div>-->
            <!--            <span class="setting-info-name"></span>-->
            <!--            <a-button htmlType="submit" class="btn-green">确认修改</a-button>-->
            <!--          </div>-->
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resetPassword } from "@/api/login/account";

export default {
  data() {
    return {
      currentPasswordIcon: false,
      newPasswordIcon: false,
      confirmNewPasswordIcon: false,
      form: this.$form.createForm(this),
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          resetPassword(values)
            .then((res) => {
              if (res.success) {
                this.$message.info("操作成功");
                this.form.resetFields();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((e) => {
              this.$message.error(e.msg);
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.setting-info-body {
  width: 1240px;
  height: 100%;
  background: #fafafa;
  margin: 0 auto;

  > div {
    padding: 24px;

    .bind-title {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      > p {
        flex: 1;
        height: 32px;
        background: #edfcf7;
        border: 1px solid #bbf0de;
        border-radius: 2px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        color: #1abc9c;

        > i {
          margin-right: 8px;
        }
      }
    }

    .setting-info-content {
      padding-top: 80px;
      display: flex;
      justify-content: center;
    }

    .bind-from > form .pwd-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 24px;

      .setting-info-name {
        width: 80px;
        white-space: nowrap;
        text-align: right;
      }

      > div {
        width: 400px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
